<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  computed: {
    tabsFieldsSchema() {
      if (!Array.isArray(this.form.items)) {
        this.$set(this.form, 'items', [])
      }
      return [
        {
          label: 'General',
          fields: [
            ...this.getCommonFields(),
            new fields.WYSIWYG({
              label: 'Title',
              modelPath: [this, 'form', 'title'],
              multilingual: true,
              required: true
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              items: this.form.items.map((item, i) => {
                return {
                  headerLabel: `Logotype #${i + 1}`,
                  fields: [
                    new fields.Image({
                      label: 'Image',
                      modelPath: [this, 'form', 'items', i, 'image'],
                      required: true,
                      onlyShowNormalCrop: true
                    }),
                    new fields.Link({
                      label: 'Link (redirects on image click)',
                      modelPath: [this, 'form', 'items', i, 'link']
                    })
                  ]
                }
              })
            })
          ]
        }
      ]
    }
  }
}
</script>
